import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { setSearchParams } from 'store/actions';

const RouteHandler = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { tourId, groupId, sceneId, hotspotId } = useSelector(
    (state) => state.worldParams
  );
  const query = useMemo(() => new URLSearchParams(location.search), [location]);
  const queries = useMemo(() => {
    const data = {};
    query.forEach((value, key) => {
      data[key] = value;
    });
    return data;
  }, [query]);

  useEffect(() => {
    dispatch(setSearchParams(queries));
  }, [queries, dispatch]);

  useEffect(() => {
    const routeParams = [tourId, groupId, sceneId, hotspotId].filter(Boolean);
    const newPath = `/${routeParams.join('/')}`;
    if (location.pathname !== newPath) {
      history.push(newPath);
    }
  }, [groupId, history, hotspotId, sceneId, tourId, location.pathname]);

  return <></>;
};

export default withRouter(RouteHandler);